export const fxgptChatSuggestionsByLanguage: any = {
  English: [
    `What is the current trend and sentiment for {symbol} based on live prices and recent news updates?`,
    `What are the key support and resistance levels for {symbol} based on current market data?`,
    `Are there any upcoming economic events or news releases likely to impact {symbol}?`,
    `What is the current volatility level for {symbol}, and how does it compare to recent historical data?`,
    `What are the major factors influencing {symbol} right now, including interest rate differentials or geopolitical developments?`,
    `What trading opportunities or potential setups can you identify for {symbol} based on live market conditions?`,
  ],
  Chinese: [
    `根据实时价格和最新新闻，{symbol} 当前的趋势和市场情绪如何？`,
    `基于当前市场数据，{symbol} 的关键支撑和阻力位在哪里？`,
    `是否有即将发布的经济事件或新闻可能影响 {symbol}？`,
    `{symbol} 当前的波动性如何，与近期历史数据相比如何？`,
    `当前有哪些主要因素（如利率差异或地缘政治）正在影响 {symbol}？`,
    `根据实时市场情况，有哪些关于 {symbol} 的交易机会或潜在策略？`,
  ],
  Japanese: [
    `{symbol} の現在のトレンドとセンチメントは、最新の価格とニュースに基づいてどうなっていますか？`,
    `{symbol} の現在の市場データに基づく主要なサポートとレジスタンスの水準は？`,
    `{symbol} に影響を与える可能性のある経済イベントやニュースリリースはありますか？`,
    `{symbol} の現在のボラティリティはどのくらいで、過去と比べてどうですか？`,
    `金利差や地政学的要因など、{symbol} に影響を与えている主な要素は？`,
    `現在の市場状況に基づいて、{symbol} に関する取引チャンスやセットアップはありますか？`,
  ],
  Korean: [
    `{symbol}의 현재 추세와 시장 심리는 실시간 가격과 최근 뉴스에 기반해 어떻게 평가되나요?`,
    `{symbol}의 주요 지지 및 저항 수준은 현재 시장 데이터를 기준으로 어디에 위치하나요?`,
    `{symbol}에 영향을 줄 수 있는 예정된 경제 이벤트나 뉴스 발표가 있나요?`,
    `{symbol}의 현재 변동성 수준은 어떤가요? 최근 데이터와 비교하면 어떤가요?`,
    `{symbol}에 현재 영향을 미치고 있는 주요 요인에는 금리 차이나 지정학적 상황 등이 있나요?`,
    `현재 시장 상황에 기반해 {symbol}에 대한 거래 기회나 잠재적 전략은 어떤 것이 있나요?`,
  ],
  Hindi: [
    `लाइव कीमतों और हालिया समाचारों के आधार पर {symbol} का वर्तमान ट्रेंड और भावना क्या है?`,
    `{symbol} के लिए वर्तमान बाजार डेटा के अनुसार प्रमुख समर्थन और प्रतिरोध स्तर क्या हैं?`,
    `{symbol} को प्रभावित करने वाली कोई आगामी आर्थिक घटनाएं या समाचार रिलीज़ हैं क्या?`,
    `{symbol} की वर्तमान अस्थिरता क्या है और यह हालिया ऐतिहासिक डेटा की तुलना में कैसी है?`,
    `{symbol} को अभी प्रभावित करने वाले मुख्य कारक क्या हैं, जैसे ब्याज दर में अंतर या भू-राजनीतिक घटनाएं?`,
    `वर्तमान बाजार स्थितियों के आधार पर {symbol} में कौन से ट्रेडिंग अवसर या संभावित सेटअप उपलब्ध हैं?`,
  ],
  Indonesian: [
    `Apa tren dan sentimen saat ini untuk {symbol} berdasarkan harga live dan berita terkini?`,
    `Apa level support dan resistance utama untuk {symbol} berdasarkan data pasar saat ini?`,
    `Apakah ada acara ekonomi atau rilis berita yang akan datang yang mungkin mempengaruhi {symbol}?`,
    `Seberapa tinggi tingkat volatilitas saat ini untuk {symbol}, dan bagaimana dibandingkan dengan data historis baru-baru ini?`,
    `Apa faktor utama yang mempengaruhi {symbol} saat ini, termasuk perbedaan suku bunga atau perkembangan geopolitik?`,
    `Peluang trading atau setup potensial apa yang bisa diidentifikasi untuk {symbol} berdasarkan kondisi pasar saat ini?`,
  ],
  Vietnamese: [
    `Xu hướng và tâm lý hiện tại của {symbol} là gì dựa trên giá trực tiếp và tin tức gần đây?`,
    `Các mức hỗ trợ và kháng cự chính của {symbol} theo dữ liệu thị trường hiện tại là gì?`,
    `Có sự kiện kinh tế hoặc tin tức nào sắp diễn ra có thể ảnh hưởng đến {symbol} không?`,
    `Mức độ biến động hiện tại của {symbol} như thế nào so với dữ liệu lịch sử gần đây?`,
    `Những yếu tố chính nào đang ảnh hưởng đến {symbol} hiện nay, bao gồm chênh lệch lãi suất hoặc tình hình địa chính trị?`,
    `Những cơ hội giao dịch hoặc thiết lập tiềm năng nào có thể được xác định cho {symbol} dựa trên điều kiện thị trường hiện tại?`,
  ],
  Thai: [
    `แนวโน้มและความเชื่อมั่นของ {symbol} ปัจจุบันคืออะไร โดยอิงจากราคาสดและข่าวล่าสุด?`,
    `ระดับแนวรับและแนวต้านที่สำคัญของ {symbol} ตามข้อมูลตลาดปัจจุบันคืออะไร?`,
    `มีเหตุการณ์ทางเศรษฐกิจหรือข่าวใดที่กำลังจะเกิดขึ้นซึ่งอาจส่งผลต่อ {symbol} หรือไม่?`,
    `ความผันผวนในปัจจุบันของ {symbol} เป็นอย่างไรเมื่อเทียบกับข้อมูลในอดีต?`,
    `ปัจจัยหลักใดที่กำลังส่งผลต่อ {symbol} เช่น ความแตกต่างของอัตราดอกเบี้ยหรือสถานการณ์ทางภูมิรัฐศาสตร์?`,
    `มีโอกาสในการซื้อขายหรือการตั้งค่าทางกลยุทธ์ใดที่สามารถระบุได้สำหรับ {symbol} ตามสภาพตลาดปัจจุบันหรือไม่?`,
  ],
};

export const defaultMessageByLanguage: Record<string, string> = {
  English: "Hello! How can I assist you today?",
  Arabic: "مرحبًا! كيف يمكنني مساعدتك اليوم؟",
  French: "Bonjour ! Comment puis-je vous aider aujourd'hui ?",
  German: "Hallo! Wie kann ich Ihnen heute helfen?",
  Spanish: "¡Hola! ¿En qué puedo ayudarle hoy?",
  Japanese: "こんにちは！本日はいかがお手伝いできますか？",
  Thai: "สวัสดีค่ะ! วันนี้ฉันสามารถช่วยคุณเรื่องอะไรได้บ้าง?", // polite & gender-neutral
  Chinese: "你好！我今天可以为您做些什么？",
  Indonesian: "Halo! Apa yang bisa saya bantu hari ini?",
  Korean: "안녕하세요! 무엇을 도와드릴까요?",
  Hindi: "नमस्ते! क्या मैं आपकी सहायता कर सकता हूं?",
  Vietnamese: "",
};

export const enterMessageByLanguage: Record<string, string> = {
  English: "Enter the question...",
  Arabic: "أدخل السؤال...",
  French: "Entrez la question...",
  German: "Geben Sie die Frage ein...",
  Spanish: "Ingresa la pregunta...",
  Japanese: "質問を入力してください...",
  Thai: "กรอกคำถามของคุณ...",
  Chinese: "请输入您的问题...",
  Indonesian: "Masukkan pertanyaannya...",
  Korean: "질문을 입력하세요...",
  Hindi: "प्रश्न दर्ज करें...",
  Vietnamese: "Nhập câu hỏi của bạn...",
};
